module.exports = __webpack_public_path__ + "img/mh.63433c4c.svg";